<template>
  <div>
    <div v-if="currentStep === 1">
      <div class="home">
        <div class="container form-container1 text-center fadeInDown">
          <div class="row">
            <div class="col-xl-6 text-center">
              <div class="card checkinCard">
                <div class="card-body text-center">
                  <h4 class="font-weight-bold indigo-text">Checkin</h4>
                  <p>Click on the button below to start</p>

                  <a
                    type="button"
                    @click="nextStageClick(2)"
                    class="btn btn-outline-success waves-effect"
                    >Checkin</a
                  >
                </div>
              </div>
            </div>

            <div class="col-xl-6 text-center">
              <div class="card checkinCard">
                <div class="card-body text-center">
                  <h4 class="font-weight-bold indigo-text">
                    Veins Express Checkin
                  </h4>
                  <p>Have a Veins ID?</p>
                  <a
                    type="button"
                    @click="nextStageClick(2)"
                    class="btn btn-outline-success waves-effect"
                    >Checkin</a
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="card col" id="backbtncard">
              <a href="index.html">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Visit Type -->
    <div v-if="currentStep === 2">
      <section id="step-1" class="section active m-b-40">
        <div class="container form-container text-center slide">
          <div class="container text-center" id="middleFix">
            <h2 class="font-weight-bold text-uppercase">Select Visit Type</h2>
            <!--Checkbox-->
            <div class="form-group">
              <div
                class="form-checkbox"
                v-for="(type, ndx01) in types"
                :key="type.visitTypeId"
                @click="visitTypeClick(ndx01)"
              >
                <input
                  v-if="currentSelectedTypeId == type.visitTypeId"
                  required
                  class="radio"
                  type="radio"
                  name=""
                  value=""
                  checked="checked"
                />
                <label class="checklabel" for="">{{ type.name }}</label>
              </div>
            </div>
            <!--Checkbox-->
          </div>

          <div class="row">
            <div class="card col" id="backbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                  @click="nextStageClick(1)"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                  @click="nextStageClick(3)"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- END visit Type -->

    <!-- Visit Reason START -->
    <div v-if="currentStep === 3">
      <section id="step-2" class="section active m-b-40">
        <div class="container form-container text-center slide">
          <div class="container text-center" id="middleFix">
            <h2 class="font-weight-bold text-uppercase">Select Visit Reason</h2>
            <!--Checkbox-->
            <div
              class="form-group"
              v-for="(reason, ndx02) in visitTypeReasons"
              :key="ndx02"
              @click="reasonClick(ndx02)"
            >
              <div class="form-checkbox">
                <input
                  v-if="currentSelectedReasonId == reason.visitDetailId"
                  required
                  class="radio"
                  type="radio"
                  name=""
                  value=""
                  checked="checked"
                />
                <!-- <input
                required
                class="radio"
                type="radio"
                name=""
                id=""
                value=""
              /> -->
                <label class="checklabel" for="">{{ reason.reasonName }}</label>
              </div>
            </div>
            <!--Checkbox-->
          </div>

          <div class="row">
            <div class="card col" id="backbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                  @click="nextStageClick(2)"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                  @click="nextStageClick(4)"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Visit Reason END -->

    <!-- Basic Details BEGIN -->
    <div v-if="currentStep === 4">
      <section id="step-3" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">Basic Details</h3>
          <form class="floating-labels">
            <!-- first row -->
            <div class="row">
              <div class="col-lg-12">
                <!-- first name -->
                <div class="form-group focused m-b-40">
                  <input
                    type="text"
                    class="form-control required"
                    id="filler_name"
                    name="filler_name"
                    v-model="basicDetails.firstName"
                  />
                  <label for="float-label">First Name</label>
                </div>
                <!-- first name -->
              </div>
              <div class="col-lg-12">
                <!-- last name -->
                <div class="form-group m-b-40">
                  <input
                    type="text"
                    class="form-control required"
                    id=""
                    placeholder=""
                    v-model="basicDetails.lastName"
                  /><span class="bar"></span>
                  <label for="">Last Name</label>
                </div>
                <!-- last name -->
              </div>
            </div>
            <!-- first row -->

            <!-- second row -->
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <input
                    type="date"
                    class="form-control required"
                    id="dob"
                    v-model="basicDetails.dob"
                    placeholder=""
                  /><span class="bar"></span>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <select class="form-control custom-select" tabindex="1">
                    <option value="">Choose a Gender</option>
                    <option value="">Male</option>
                    <option value="">Female</option>
                    <option value="">Others</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- second row -->

            <!-- fourth row -->
            <div class="row">
              <div class="form-group m-b-40 col-12">
                <input
                  type="text"
                  class="form-control required"
                  id=""
                  placeholder=""
                  v-model="basicDetails.ssn"
                /><span class="bar"></span>
                <label for="">Social Security Number</label>
              </div>
            </div>
            <!-- fourth row -->
          </form>

          <div class="row">
            <div class="card col" id="backbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                  @click="nextStageClick(3)"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                  @click="nextStageClick(5)"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Basic Details END -->

    <!-- Contact Information BEGIN -->
    <div v-if="currentStep === 5">
      <section id="step-4" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">
            Contact Information
          </h3>
          <form class="floating-labels">
            <!-- third row -->
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <input
                    type="tel"
                    class="form-control required"
                    id=""
                    placeholder=""
                    v-model="basicDetails.phone"
                  /><span class="bar"></span>
                  <label for="">Phone Number</label>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <input
                    type="email"
                    class="form-control required"
                    id=""
                    placeholder=""
                    v-model="basicDetails.email"
                  /><span class="bar"></span>
                  <label for="">Email</label>
                </div>
              </div>
            </div>
            <!-- third row -->
          </form>

          <div class="row">
            <div class="card col" id="backbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                  @click="nextStageClick(4)"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                  @click="nextStageClick(6)"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Contact Information END -->

    <!-- Address BEGIN -->
    <div v-if="currentStep === 6">
      <section id="step-5" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">Address</h3>
          <form class="floating-labels">
            <!-- fifth row -->
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <input
                    type="text"
                    class="form-control required"
                    id=""
                    placeholder=""
                    v-model="basicDetails.address"
                  /><span class="bar"></span>
                  <label for="street">Street</label>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <input
                    type="text"
                    class="form-control required"
                    id=""
                    placeholder=""
                    v-model="basicDetails.city"
                  /><span class="bar"></span>
                  <label for="city">City</label>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <input
                    type="text"
                    class="form-control required"
                    id=""
                    placeholder=""
                    v-model="basicDetails.zip"
                  /><span class="bar"></span>
                  <label for="zip">Zip</label>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <select
                    class="form-control custom-select"
                    tabindex="1"
                    v-model="basicDetails.state"
                  >
                    <option value="">Choose State</option>
                    <option value="FL">FL</option>
                    <option value="AL">AL</option>
                    <option value="AK">AK</option>
                    <option value="AZ">AZ</option>
                    <option value="AR">AR</option>
                    <option value="CA">CA</option>
                    <option value="CO">CO</option>
                    <option value="CT">CT</option>
                    <option value="DE">DE</option>
                    <option value="GA">GA</option>
                    <option value="HI">HI</option>
                    <option value="ID">ID</option>
                    <option value="IL">IL</option>
                    <option value="IN">IN</option>
                    <option value="IA">IA</option>
                    <option value="KS">KS</option>
                    <option value="KY">KY</option>
                    <option value="ME">ME</option>
                    <option value="MD">MD</option>
                    <option value="MA">MA</option>
                    <option value="MI">MI</option>
                    <option value="MN">MN</option>
                    <option value="MS">MS</option>
                    <option value="MO">MO</option>
                    <option value="MT">MT</option>
                    <option value="NE">NE</option>
                    <option value="NV">NV</option>
                    <option value="NH">NH</option>
                    <option value="NJ">NJ</option>
                    <option value="NM">NM</option>
                    <option value="NY">NY</option>
                    <option value="NC">NC</option>
                    <option value="ND">ND</option>
                    <option value="OH">OH</option>
                    <option value="OK">OK</option>
                    <option value="OR">OR</option>
                    <option value="PA">PA</option>
                    <option value="RI">RI</option>
                    <option value="SC">SC</option>
                    <option value="SD">SD</option>
                    <option value="TN">TN</option>
                    <option value="TX">TX</option>
                    <option value="UT">UT</option>
                    <option value="VT">VT</option>
                    <option value="VA">VA</option>
                    <option value="WA">WA</option>
                    <option value="WV">WV</option>
                    <option value="WI">WI</option>
                    <option value="WY">WY</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- fifth row -->
          </form>

          <div class="row">
            <div class="card col" id="backbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                  @click="nextStageClick(5)"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                  @click="nextStageClick(7)"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Address END -->

    <!-- Custom Demo START -->
    <div v-if="currentStep === 7">
      <!-- *66* 
    1: Textbox
    2: Checkbox
    3: Rating
    4: Radio Button
    5: Email
    6: Phone Number
    7: Date -->
      <section id="" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">Custom Demo</h3>
          <form class="floating-labels" v-if="reasonDemos.length > 0">
            <div v-for="(res, ndx03) in reasonDemos" :key="ndx03">
              <!-- **** TEXT **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 1">
                <fieldset class="floating-labels">
                  <div class="form-group m-b-40">
                    <input
                      type="text"
                      class="form-control required"
                      id=""
                      placeholder=""
                      v-model="res.demo.answer"
                    /><span class="bar"></span>
                    <label for="street">{{ res.demo.question }}</label>
                  </div>
                </fieldset>
              </div>

              <!-- **** CHECK BOX **** -->
              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 2"
              >
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p class="boldText">
                      {{ res.demo.question }}
                    </p>
                  </div>
                </fieldset>
                <div class="input-group">
                  <div
                    class="row"
                    v-for="(op, ndx04) in res.demo.demoOptions"
                    :key="ndx04"
                  >
                    <div style="margin-right: 100px">
                      <input
                        class="input1"
                        type="checkbox"
                        value="3"
                        name="checkbox"
                        id=""
                      />
                      <label
                        for="checkbox1"
                        @click="demoOptionSelected(ndx03, ndx04)"
                        class="btn btn-outline-info label2"
                        >{{ op.questOption }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** RATING **** -->
              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 3"
              >
                <div class="form-group">
                  <p class="boldText">{{ res.demo.question }}</p>
                  <div class="input-group">
                    <div class="floating-labels">
                      <div class="row">
                        <div
                          class="form-group col-1 m-r-40"
                          v-for="(op, ndx04) in res.demo.demoOptions"
                          :key="ndx04"
                        >
                          <input
                            class="input1"
                            type="radio"
                            value="1"
                            name="radio"
                            id="radio1"
                          />
                          <label
                            for="radio1"
                            class="btn btn-outline-info label1"
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="op.questOption"
                            @click="demoOptionSelected(ndx03, ndx04)"
                            >O{{ ndx04 + 1 }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** RADIO BUTTON **** -->
              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 4"
              >
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p class="boldText">
                      {{ res.demo.question }}
                    </p>
                  </div>
                </fieldset>
                <div class="input-group">
                  <div class="row">
                    <div
                      style="margin-right: 100px"
                      v-for="(op, ndx04) in res.demo.demoOptions"
                      :key="ndx04"
                    >
                      <input
                        class="input1"
                        type="radio"
                        value="1"
                        name="radio"
                        id="radio1"
                      />
                      <label
                        for="radio1"
                        class="btn btn-outline-info label1"
                        @click="demoOptionSelected(ndx03, ndx04)"
                        >{{ op.questOption }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** EMAIL **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 5">
                <fieldset class="floating-labels">
                  <div class="form-group m-b-40">
                    <input
                      type="text"
                      class="form-control required"
                      id=""
                      placeholder=""
                      v-model="res.demo.answer"
                    /><span class="bar"></span>
                    <label for="street">{{ res.demo.question }}</label>
                  </div>
                </fieldset>
              </div>

              <!-- **** PHONE **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 6">
                <fieldset class="floating-labels">
                  <div class="form-group m-b-40">
                    <input
                      type="tel"
                      class="form-control required phone-inputmask"
                      id=""
                      placeholder=""
                      v-model="res.demo.answer"
                    /><span class="bar"></span>
                    <label for="street">{{ res.demo.question }}</label>
                  </div>
                </fieldset>
              </div>

              <!-- **** DATE **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 7">
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p class="boldText">{{ res.demo.question }}</p>
                  </div>
                  <div class="form-group" style="margin-top: -18px">
                    <input
                      type="date"
                      class="form-control"
                      id=""
                      v-model="res.demo.answer"
                    /><span class="bar"></span>
                  </div>
                </fieldset>
              </div>
            </div>
          </form>

          <div class="row">
            <div class="card col" id="backbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                  @click="nextStageClick(6)"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                  @click="nextStageClick(8)"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Custom Demo START -->

    <!-- Questionnaire START -->
    <div v-if="currentStep === 8">
      <section id="step-7" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">Questionnaire</h3>
          <!-- ------------------------------------- -->
          <form class="floating-labels" v-if="reasonQuests.length > 0">
            <div v-for="(res, ndx03) in reasonQuests" :key="ndx03">
              <!-- **** TEXT **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 1">
                <fieldset class="floating-labels">
                  <div class="form-group m-b-40">
                    <input
                      type="text"
                      class="form-control required"
                      id=""
                      placeholder=""
                      v-model="res.demo.answer"
                    /><span class="bar"></span>
                    <label for="street">{{ res.demo.question }}</label>
                  </div>
                </fieldset>
              </div>

              <!-- **** CHECK BOX **** -->
              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 2"
              >
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p class="boldText">
                      {{ res.demo.question }}
                    </p>
                  </div>
                </fieldset>
                <div class="input-group">
                  <div
                    class="row"
                    v-for="(op, ndx04) in res.demo.demoOptions"
                    :key="ndx04"
                  >
                    <div style="margin-right: 100px">
                      <input
                        class="input1"
                        type="checkbox"
                        value="3"
                        name="checkbox"
                        id=""
                      />
                      <label
                        for="checkbox1"
                        @click="questOptionSelected(ndx03, ndx04)"
                        class="btn btn-outline-info label2"
                        >{{ op.questOption }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** RATING **** -->
              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 3"
              >
                <div class="form-group">
                  <p class="boldText">{{ res.demo.question }}</p>
                  <div class="input-group">
                    <div class="floating-labels">
                      <div class="row">
                        <div
                          class="form-group col-1 m-r-40"
                          v-for="(op, ndx04) in res.demo.demoOptions"
                          :key="ndx04"
                        >
                          <input
                            class="input1"
                            type="radio"
                            value="1"
                            name="radio"
                            id="radio1"
                          />
                          <label
                            for="radio1"
                            class="btn btn-outline-info label1"
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="op.questOption"
                            @click="questOptionSelected(ndx03, ndx04)"
                            >O{{ ndx04 + 1 }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** RADIO BUTTON **** -->
              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 4"
              >
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p class="boldText">
                      {{ res.demo.question }}
                    </p>
                  </div>
                </fieldset>
                <div class="input-group">
                  <div class="row">
                    <div
                      style="margin-right: 100px"
                      v-for="(op, ndx04) in res.demo.demoOptions"
                      :key="ndx04"
                    >
                      <input
                        class="input1"
                        type="radio"
                        value="1"
                        name="radio"
                        id="radio1"
                      />
                      <label
                        for="radio1"
                        class="btn btn-outline-info label1"
                        @click="questOptionSelected(ndx03, ndx04)"
                        >{{ op.questOption }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** EMAIL **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 5">
                <fieldset class="floating-labels">
                  <div class="form-group m-b-40">
                    <input
                      type="text"
                      class="form-control required"
                      id=""
                      placeholder=""
                      v-model="res.demo.answer"
                    /><span class="bar"></span>
                    <label for="street">{{ res.demo.question }}</label>
                  </div>
                </fieldset>
              </div>

              <!-- **** PHONE **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 6">
                <fieldset class="floating-labels">
                  <div class="form-group m-b-40">
                    <input
                      type="tel"
                      class="form-control required phone-inputmask"
                      id=""
                      placeholder=""
                      v-model="res.demo.answer"
                    /><span class="bar"></span>
                    <label for="street">{{ res.demo.question }}</label>
                  </div>
                </fieldset>
              </div>

              <!-- **** DATE **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 7">
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p class="boldText">{{ res.demo.question }}</p>
                  </div>
                  <div class="form-group" style="margin-top: -18px">
                    <input
                      type="date"
                      class="form-control"
                      id=""
                      v-model="res.demo.answer"
                    /><span class="bar"></span>
                  </div>
                </fieldset>
              </div>
            </div>
          </form>
          <!-- ------------------------------------- -->
          <div class="row">
            <div class="card col" id="backbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                  @click="nextStageClick(7)"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                  @click="nextStageClick(9)"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Questionnaire END -->

    <!-- Patient Information START -->
    <div v-if="currentStep === 9">
      <section id="step-8" class="section active m-b-40">
        <div class="container form-container slide">
          <div class="col-12" id="strips1">
            <h4 class="font-weight-bold my-3">Patient Information</h4>
          </div>
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>First Name</th>
                <td id="td1">{{ basicDetails.firstName }}</td>
              </tr>
              <tr>
                <th>Last Name</th>
                <td id="td1">{{ basicDetails.lastName }}</td>
              </tr>
              <tr>
                <th>Date of Birth</th>
                <td id="td1">{{ basicDetails.dob }}</td>
              </tr>
              <tr>
                <th>Sex</th>
                <td id="td1">Male</td>
              </tr>
              <tr>
                <th>SSN</th>
                <td id="td1">{{ basicDetails.ssn }}</td>
              </tr>
            </tbody>
          </table>
          <div class="col-12" id="strips1">
            <h4 class="font-weight-bold my-3">Contact Information</h4>
          </div>
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>Email Address</th>
                <td id="td1">
                  <a
                    href="/cdn-cgi/l/email-protection"
                    class="__cf_email__"
                    data-cfemail="1360727d6072617a6153747e727a7f3d707c7e"
                    >[email&#160;protected]</a
                  >
                </td>
              </tr>
              <tr>
                <th>Phone Number</th>
                <td id="td1">{{ basicDetails.phone }}</td>
              </tr>
            </tbody>
          </table>

          <div class="col-12" id="strips1">
            <h4 class="font-weight-bold my-3">Address</h4>
          </div>
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>Street</th>
                <td id="td1">{{ basicDetails.address }}</td>
              </tr>
              <tr>
                <th>City</th>
                <td id="td1">{{ basicDetails.city }}</td>
              </tr>
              <tr>
                <th>State</th>
                <td id="td1">{{ basicDetails.state }}</td>
              </tr>
              <tr>
                <th>Zip</th>
                <td id="td1">{{ basicDetails.zip }}</td>
              </tr>
            </tbody>
          </table>

          <div class="col-12" id="strips1">
            <h4 class="font-weight-bold my-3">Visit Information</h4>
          </div>
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>Visit Type</th>
                <td id="td1">{{ activeType.name }}</td>
              </tr>
              <tr>
                <th>Visit Reason</th>
                <td id="td1">{{ activeReason.reasonName }}</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="card col" id="backbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                  @click="nextStageClick(8)"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard">
              <a href="#dummy998">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn99"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="prevbtn111"
                  @click="saveCheckinInfo"
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section id="step-9" class="section active m-b-40">
        <div class="container form-container slide">
          <h3 class="text-center boldText">THANK YOU FOR VISITING VEINS</h3>
        </div>
      </section>
    </div>
    <!-- Patient Information END -->

    <!-- Thanks Message START -->
    <div v-if="currentStep === 10">
      <section id="step-9" class="section active m-b-40">
        <div class="container form-container slide">
          <h3 class="text-center boldText">THANK YOU FOR VISITING VEINS</h3>
        </div>
      </section>
    </div>
    <!-- Thanks Message END -->

    <!-- 2nd div -->
    <div v-if="currentStep === -2">
      <section id="step-3" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">
            Please Enter Veins ID
          </h3>
          <form class="floating-labels">
            <!-- third row -->
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <input
                    v-model="veinsId"
                    type="text"
                    class="form-control required"
                    id=""
                    placeholder=""
                  /><span class="bar"></span>
                  <label for="">Veins ID</label>
                </div>
              </div>

              <button
                @click="verifyClick(-1)"
                class="btn btn-outline-success col-12"
              >
                Verify
              </button>
              <!-- <button
              class="btn btn-outline-success waves-effect col-12 m-b-10"
              data-dismiss="modal"
            >
              Profile Found
            </button>
            <button
              class="btn btn-outline-danger waves-effect col-12"
              type="button"
              data-toggle="modal"
              data-target="#profileNotFound"
            >
              Profile Not Found
            </button> -->
            </div>
            <!-- third row -->
          </form>
        </div>
      </section>
    </div>

    <!-- Confirm DOB -->
    <div v-if="currentStep === 333">
      <section id="step-4" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">Date Of Birth</h3>
          <form class="floating-labels">
            <!-- third row -->
            <div class="alert alert-success text-center">
              Looks like we found your profile! Profile Enter your DOB to verify
              your identity
            </div>
            <form action="">
              <div class="form-group">
                <input type="date" class="form-control" id="" name="" />
              </div>

              <button
                class="btn btn-outline-success waves-effect waves-light col-12"
              >
                Verify
              </button>
            </form>
            <!-- third row -->
          </form>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CheckIn",
  components: {},

  data() {
    return {
          //Timer
      TimerObject: {},
      veinsId: "",
      patientsIdsLst: [],

      currentStep: 1,

      types: [],
      reasons: [],
      demos: [],
      quests: [],

      actualDemos: [],
      actualQuestions: [],
      questionOptions: [],
      visitTypeQuestDemo: [],

      basicDetails: {
        pndx: 0,
        patientId: 0,
        firstName: "sdf",
        lastName: "wwrwer",
        currentdate: new Date(),
        dos: "",
        dob: "",
        gender: "Male",
        ssn: "123",
        phone: "",
        email: "",
        address: "",
        city: "",
        zip: "",
        state: "",
      },

      activeType: "",
      activeReason: "",
      visitTypeReasons: "",

      currentSelectedTypeId: -1,
      currentSelectedReasonId: -1,

      reasonQuests: [],
      reasonDemos: [],
      activeDemo: {
        reasonId: 0,
        visitDetailId: 0,
        demo: {
          questId: 0,
          srNo: 0,
          questName: "",
          question: "",
          answer: "",
          questionInputTypeId: 0,
          questTypeName: "",
          demoOptions: {
            srNo: 0,
            questOption: "",
          },
        },
      },
    };
  }, // data

  methods: {
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, 1.8e+6);
    },
    ResetLogoutTime(){
      clearTimeout(this.TimerObject);
          this.TimerObject = setTimeout(() => {
           this.AutoLogout();
          }, 1.8e+6);
    },

    saveCheckinInfo() {
      //let bd = this.basicDetails;
      let currentdate = new Date();
      this.basicDetails.dos =
        currentdate.getFullYear() +
        "-" +
        String(currentdate.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(currentdate.getDate()).padStart(2, "0") +
        " " +
        String(currentdate.getHours()).padStart(2, "0") +
        ":" +
        String(currentdate.getMinutes()).padStart(2, "0") +
        ":" +
        String(currentdate.getSeconds()).padStart(2, "0");

      this.basicDetails.physicianId = this.activeReason.physicianId;
      let mydata = {
        visitTypeId: this.activeType.visitTypeId,
        visitDetailId: this.activeReason.visitDetailId,
        questDemos: [],
        basicDetail: this.basicDetails,
        dc: this.dummyComm,
      };

      let x = this.reasonDemos.length;
      for (let i = 0; i < x; i++) {
        const obj = {
          questId: this.reasonDemos[i].demo.questId,
          answer: this.reasonDemos[i].demo.answer,
          isDemo: 1,
        };

        mydata.questDemos.push(obj);
      }

      x = this.reasonQuests.length;
      for (let i = 0; i < x; i++) {
        const obj = {
          questId: this.reasonQuests[i].demo.questId,
          answer: this.reasonQuests[i].demo.answer,
          isDemo: 0,
        };

        mydata.questDemos.push(obj);
      }

      this.intDummyComm();
      this.dummyComm.extras = "";
      mydata.dc = this.dummyComm;
      const url = this.SERVER + "/VNSPRAAPI/Checkin/SvChknPat";
      //const paraData = { dc: this.dummyComm, data: mydata};
      //this.axiosGetData(url, mydata, 2);
      this.axiosGetData(url, mydata, 2);

      console.log(this.basicDetails);
      console.log(mydata);
    },

    demoOptionSelected(ndx1, ndx2) {
      this.reasonDemos[ndx1].demo.answer =
        this.reasonDemos[ndx1].demo.demoOptions[ndx2].questOptionId;
    },

    questOptionSelected(ndx1, ndx2) {
      console.log(this.reasonQuests[ndx1]);
      this.reasonQuests[ndx1].demo.answer =
        this.reasonQuests[ndx1].demo.demoOptions[ndx2].questOptionId;
      console.log(ndx1, ndx2);
      console.log(this.reasonQuests[ndx1].demo.answer);
    },

    makeReasonQuests() {
      //alert(999)
      this.reasonQuests = [];
      //let obj = this.actualQuestions;
      let obj = this.blankActiveDemo();
      obj.visitDetailId = this.activeReason.visitDetailId;
      let x = this.visitTypeQuestDemo.length;
      for (let i = 0; i < x; i++) {
        if (
          this.visitTypeQuestDemo[i].isDemo == 0 &&
          this.visitTypeQuestDemo[i].visitDetailId == obj.visitDetailId
        ) {
          obj = this.blankActiveDemo();
          obj.visitDetailId = this.activeReason.visitDetailId;
          obj.demo.questId = this.visitTypeQuestDemo[i].questId;
          obj.demo.srNo = this.visitTypeQuestDemo[i].srNo;
          let y = this.actualQuestions.length;
          for (let j = 0; j < y; j++) {
            if (this.actualQuestions[j].questId == obj.demo.questId) {
              obj.demo.questName = this.actualQuestions[j].questName;
              obj.demo.question = this.actualQuestions[j].question;
              obj.demo.questTypeName = this.actualQuestions[j].questTypeName;
              obj.demo.questionInputTypeId =
                this.actualQuestions[j].questionInputTypeId;
              break;
            }
          }

          y = this.questionOptions.length;
          for (let j = 0; j < y; j++) {
            if (this.questionOptions[j].questId == obj.demo.questId) {
              let objP = {
                questId: obj.demo.questId,
                questOption: this.questionOptions[j].questOption,
                questOptionId: this.questionOptions[j].questOptionId,
              };
              obj.demo.demoOptions.push(objP);
            }
          }

          this.reasonQuests.push(obj);
          console.log(obj);
        } // main if
      } // main for
    },

    makeReasonDemos() {
      this.reasonDemos = [];
      //let obj = this.actualDemo;
      let obj = this.blankActiveDemo();
      obj.visitDetailId = this.activeReason.visitDetailId;
      let x = this.visitTypeQuestDemo.length;
      for (let i = 0; i < x; i++) {
        if (
          this.visitTypeQuestDemo[i].isDemo == 1 &&
          this.visitTypeQuestDemo[i].visitDetailId == obj.visitDetailId
        ) {
          //alert(9999);
          obj = this.blankActiveDemo();
          obj.visitDetailId = this.activeReason.visitDetailId;
          obj.demo.questId = this.visitTypeQuestDemo[i].questId;
          obj.demo.srNo = this.visitTypeQuestDemo[i].srNo;
          let y = this.actualDemos.length;
          for (let j = 0; j < y; j++) {
            //console.log(this.actualDemos[j].questId , obj.demo.questId);
            if (this.actualDemos[j].questId == obj.demo.questId) {
              obj.demo.questName = this.actualDemos[j].questName;
              obj.demo.answer = this.actualDemos[j].answer;
              obj.demo.question = this.actualDemos[j].question;
              obj.demo.questTypeName = this.actualDemos[j].questTypeName;
              obj.demo.questionInputTypeId =
                this.actualDemos[j].questionInputTypeId;
              {
                //alert(9999);
                break;
              }
            }
          }

          y = this.questionOptions.length;
          for (let j = 0; j < y; j++) {
            if (this.questionOptions[j].questId == obj.demo.questId) {
              let objP = {
                questId: obj.demo.questId,
                questOption: this.questionOptions[j].questOption,
                questOptionId: this.questionOptions[j].questOptionId,
              };
              obj.demo.demoOptions.push(objP);
            }
          }

          this.reasonDemos.push(obj);
          //console.log(obj);
        } // main if
      } // main for
    },

    blankActiveDemo() {
      this.activeDemo = {
        reasonId: 0,
        visitDetailId: 0,
        demo: {
          questId: 0,
          srNo: 0,
          questName: "",
          question: "",
          answer: "",
          questionInputTypeId: 0,
          questTypeName: "",
          demoOptions: [
            //   {
            //   srNo: 0,
            //   questOption: "",
            // }
          ],
        },
      };
      return this.activeDemo;
    },

    reasonClick(ndx) {
      this.currentSelectedReasonId = this.visitTypeReasons[ndx].visitDetailId;

      this.activeReason = "";
      this.activeReason = JSON.parse(
        JSON.stringify(this.visitTypeReasons[ndx])
      );

      this.makeReasonDemos();
      this.makeReasonQuests();
    },

    visitTypeClick(ndx) {
      this.currentSelectedTypeId = this.types[ndx].visitTypeId;

      this.activeType = JSON.parse(JSON.stringify(this.types[ndx]));
      this.visitTypeReasons = [];

      const x = this.reasons.length;
      for (let i = 0; i < x; i++) {
        if (this.reasons[i].visitTypeId === this.activeType.visitTypeId) {
          this.visitTypeReasons.push(
            JSON.parse(JSON.stringify(this.reasons[i]))
          );
        }
      }
      this.activeReason = "";
      this.activeReason = JSON.parse(JSON.stringify(this.visitTypeReasons[0]));
    },

    verifyClick(step) {
      // Express stage 1
      if (step == 222) {
        let found = false;
        for (let i = 0; i < this.patientsIdsLst.length; i++) {
          if (this.patientsIdsLst[i] == this.veinsId) {
            found = true;
            break;
          }
        }
        if (found) {
          this.currentStep = 333;
        }
      }
    },

    nextStageClick(step) {
      if (step === 3 && this.currentSelectedTypeId < 0) return;

      this.currentStep = step;

      // if(step==2 && this.currentSelectedTypeId<0)
      // this.currentSelectedTypeId = 1;
      //alert(this.currentStep);
    },
    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Checkin/GtBscDta";

      this.axiosGetData(url, this.dummyComm, 1);
      this.StartLogoutTime();
    }, // load Init

    //-------------------- Common Methods
    async axiosGetData(myUrl, myData, what) {
      var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          // if everything goes well -- we will get data
          if (what === 1) {
            this.patientsIdsLst = res.data.patLst;
            this.types = res.data.visits;
            this.reasons = res.data.reasons;
            this.actualDemos = res.data.actualDemos;
            this.actualQuestions = res.data.actualQuestions;
            this.questionOptions = res.data.questionOptions;
            this.visitTypeQuestDemo = res.data.visitTypeQuestDemo;
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => { loader.hide(); this.ResetLogoutTime();
          //this.datePicker();
          //this.calcTimerRoutine();
        });
    }, // axiosGetData
  }, // methods

  mounted() {
    this.loadInit();
  }, // mounted
   unmounted() {
        clearTimeout(this.TimerObject);
      },

  beforeUnmount() {
    localStorage.patientsIdsLst = this.patientsIdsLst.toString();
    localStorage.veinsId = "";
  },
};
</script>

<style scoped>
</style>
